import { lazySchema } from "@repo/lazy-schema";
import { z } from "zod";

/** Trusted service policy. Public owner/capability callers cannot supply it.
 * A null fee selects the deployment's ordinary venue fee policy; a numeric fee
 * is an explicitly authorized override. Admission freezes the effective values
 * into actions, so execution and recovery never re-read commercial preferences.
 */
export const ExecutionPolicySchema = lazySchema(() =>
  z
    .object({
      version: z.literal(1),
      swapFeeBps: z.number().int().min(0).max(500).nullable(),
      slippageBps: z.number().int().min(0).max(10_000),
      priceImpactBps: z.number().int().min(0).max(10_000),
      evmSwapProvider: z.literal("lifi"),
    })
    .strict(),
);
export type ExecutionPolicy = z.infer<typeof ExecutionPolicySchema>;
